import React from "react";
import { Container } from "@material-ui/core";
import styles from './LoginPage.module.scss';
import LanguageSelector from '../../../../components/languageSelector/LanguageSelector';

export const LoginPage = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className={styles.container}>
      <Container maxWidth="sm" className={styles.content}>
        <div style={{ position: 'absolute', top: 16, right: 16, zIndex: 10 }}>
          <LanguageSelector />
        </div>
        <div style={{ maxWidth: 462 }}>
          {children}
        </div>
        <div style={{ color: "#fff", position: "fixed", bottom: 0, right: 4 }}>0.1.8</div>
      </Container>
    </div>
  );
};
